import { render, staticRenderFns } from "./purchaseDetailInfo.vue?vue&type=template&id=759c8ef5&scoped=true&"
import script from "./purchaseDetailInfo.vue?vue&type=script&lang=js&"
export * from "./purchaseDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./purchaseDetailInfo.vue?vue&type=style&index=0&id=759c8ef5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c8ef5",
  null
  
)

export default component.exports